import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import axiosPrivate from 'config/axiosPrivate';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { lower } from 'utils/StringUtils';
import { useHistoryState } from 'utils/hooks/useHistoryState';

import { adminOrderListSelector } from 'store/Admin/OrderList';
import { adminClientListSelector } from 'store/Admin/ClientList';

import { fetchClientList } from 'store/Admin/ClientList/features';
import { removeClient } from 'store/Admin/ClientList';

import { Loader } from 'components/shared/Loader';

import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';

import './Homepage.css';
import axiosPixLink from 'config/axiosPixLink';

const API = {
  deleteWebsite: '/clientWebsite/',
};

export const SuperAdminHomePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  let {
    inProgressOrders,
    delayedOrders,
    validatedOrders,
    nonAttributedOrders,
    smartOrders,
    smartWithReviewOrders,
    isLoading,
  } = useSelector(adminOrderListSelector);

  const { t } = useTranslation();
  let { clients, isLoadingClients } = useSelector(adminClientListSelector);

  const [selectedWebsite, setSelectedWebsite] = useState(false);
  const [urlSearch, setUrlSearch] = useHistoryState('urlSearch', '');
  const [unassignedCampaignsCount, setUnassignedCampaignsCount] = useState(0);
  const [assignedCampaignsCount, setAssignedCampaignsCount] = useState(0);
  const [onlineCampaignsCount, setOnlineCampaignsCount] = useState(0);
  const [overdueCampaignsCount, setOverdueCampaignsCount] = useState(0);
  const [brouillonCampaignsCount, setBrouillonCampaignsCount] = useState(0);
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');

  useEffect(() => {
    document.title = t('PixLink - Mon tableau de bord');
    window.dispatchEvent(new Event('locationchange'));
    dispatch(fetchClientList());
  }, []);
  useEffect(() => {
    axiosPixLink
      .get(`/campaign/countEmptyConsultants`)
      .then((res) => setUnassignedCampaignsCount(res.data))
      .catch((err) => console.log(err));
    axiosPixLink
      .get(`/campaign/countOnlineCampaigns`)
      .then((res) => setOnlineCampaignsCount(res.data))
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    axiosPixLink
      .get(`/campaign/countNotEmptyConsultants`)
      .then((res) => setAssignedCampaignsCount(res.data))
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    axiosPixLink
      .get(`/campaign/countEmptyConsultantsOverdue`)
      .then((res) => setOverdueCampaignsCount(res.data))
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    axiosPixLink
      .get('/campaign/count/all/brouillon')
      .then((res) => setBrouillonCampaignsCount(res.data))
      .catch((err) => console.log(err));
  }, []);
  const DeleteWebsite = () => {
    axiosPixLink
      .delete(`/website/${selectedWebsite.id}/delete`)
      .then(() => {
        setConfirmation(false);
        dispatch(removeClient(selectedWebsite.id));

        setErrorSuccessMsg(
          `${t('Le contrat de')} ${selectedWebsite.urlSite} ${t(
            'a été supprimé avec succès'
          )} !`
        );
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch((e) => {
        setConfirmation(false);
        switch (e.response.status) {
          case 500:
            setErrorSuccessMsg(
              t("il y'a des campagnes liés au site web ") +
              selectedWebsite.urlSite
            );
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return (
    <div>
      <div className="content-center">
        <div className="mb-2">
          <h1>Dashboard</h1>
        </div>
        <div
          className="row-homePage"
          style={{ display: 'flex', alignItems: 'stretch', gap: '1rem' }}
        >
          <div className="col-12 col-md-7" style={{ display: 'flex', flexDirection: 'column', flex: '0 0 58%' }}>
            <div className="box-wrapper" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <div className="box-list-header">
                <div className="box-title"> {t('Liste des clients')} </div>
                <div className="box-input-text">
                  <div className="input-group input-cs w-100">
                    <div className="input-group-text">
                      <i className="bi bi-search" />
                    </div>
                    <input
                      type="text"
                      value={urlSearch}
                      onChange={(event) => setUrlSearch(event.target.value)}
                      className="form-control ps-0"
                      placeholder={t('Rechercher')}
                    />
                  </div>
                </div>
                <div onClick={() => history.push('/SuperAdmin/AjouterClient')}>
                  <span className="bt-plus-circle" />
                </div>
              </div>
              {isLoadingClients ? (
                <Loader />
              ) : (
                <div className="table-responsive" style={{ flex: 1 }}>
                  <table className="table-lists" style={{ width: '100%', tableLayout: 'fixed' }}>
                    <colgroup>
                      <col style={{ width: '60%' }} />
                      <col style={{ width: '14%' }} />
                      <col style={{ width: '14%' }} />
                      <col style={{ width: '12%' }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>{t('Nom client')}</th>
                        <th>{t('Campagnes')}</th>
                        <th>{t('Éditer')}</th>
                        <th>{t('Supprimer')}</th>
                      </tr>
                    </thead>
                  </table>
                  <div>
                    <table className="table-lists" style={{ width: '100%', tableLayout: 'fixed' }}>
                      <colgroup>
                        <col style={{ width: '60%' }} />
                        <col style={{ width: '14%' }} />
                        <col style={{ width: '14%' }} />
                        <col style={{ width: '12%' }} />
                      </colgroup>
                      <tbody>
                        {clients
                          ?.filter((x) => {
                            if (urlSearch && urlSearch.length > 0) {
                              return lower(x.urlSite).includes(
                                lower(urlSearch)
                              );
                            }
                            return true;
                          })
                          .map((item) => (
                            <tr key={item.id} style={{ cursor: 'pointer' }}>
                              <td
                                title={item.urlSite}
                                style={{
                                  maxWidth: 0,
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                }}
                                onClick={() => {
                                  history.push('/SuperAdmin/FicheClient/' + item.id);
                                }}
                              >
                                <span>{item.urlSite}</span>
                              </td>

                              <td onClick={() => { }}>
                                <span className="bt-circle-wh">
                                  {item.numberOfCampaigns}
                                </span>
                              </td>

                              <td
                                onClick={() => {
                                  history.push(
                                    '/SuperAdmin/FicheClient/' + item.id
                                  );
                                }}
                              >
                                <span className="bt-circle-wh">
                                  <img
                                    src="Images/icon-edit.png"
                                    alt="icon-edit"
                                  />{' '}
                                </span>
                              </td>
                              <td>
                                <span
                                  className="bt-circle-wh"
                                  onClick={() => {
                                    setSelectedWebsite(item);
                                    setConfirmationMsg(
                                      `${t(
                                        'Voulez-vous vraiment supprimer le contrat de'
                                      )} ${item.urlSite} ? `
                                    );
                                    setConfirmation(true);
                                  }}
                                >
                                  <img
                                    src="Images/icon-trash.png"
                                    alt="icon-trash"
                                  />
                                </span>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-5" style={{ display: 'flex', flexDirection: 'column', flex: '0 0 40%' }}>
            <div className="row" style={{ flex: 1, alignContent: 'flex-start' }}>
              <div className="col-12 col-md-6" style={{ display: 'flex' }}>
                <div
                  className="card box-wrapper box-pd box-pd-orange" style={{ flex: 1 }}
                  onClick={() => history.push('/SuperAdmin/CampagnesNonAttribuees')}
                >
                  <div className="box-header-icon">
                    <div className="bt-icon-list bt-icon-attr" />
                  </div>
                  <div className=" text-container label-text text-center text-wrap">
                    {t('Campagnes non attribuées')}
                  </div>
                  <div className="box-circle bg-orange">
                    {unassignedCampaignsCount ? unassignedCampaignsCount : '0'}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6" style={{ display: 'flex' }}>
                <div
                  className=" card box-wrapper box-pd box-pd-blue" style={{ flex: 1 }}
                  onClick={() => history.push('/SuperAdmin/CampagnesEnCour')}
                >
                  <div className="box-header-icon">
                    <div className="bt-icon-list bt-icon-en-cour" />
                  </div>
                  <div className="text-container label-text text-center text-wrap">
                    {t('Campagnes en cours')}
                  </div>
                  <div className="box-circle bg-blue">
                    {assignedCampaignsCount ? assignedCampaignsCount : '0'}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6" style={{ display: 'flex' }}>
                <div
                  className="card box-wrapper box-pd box-pd-darkorange" style={{ flex: 1 }}
                  onClick={() => history.push('/SuperAdmin/CampagnesEnRetard')}
                >
                  <div className="box-header-icon">
                    <div className="bt-icon-list bt-icon-en-retard" />
                  </div>
                  <div className="text-container label-text text-center text-wrap">
                    {t('Campagnes en retard')}
                  </div>
                  <div className="box-circle bg-darkorange">
                    {overdueCampaignsCount ? overdueCampaignsCount : '0'}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6" style={{ display: 'flex' }}>
                <div
                  className="card box-wrapper box-pd box-pd-green"
                  style={{ flex: 1 }}
                  onClick={() => history.push('/SuperAdmin/CampagnesEnLigne')}
                >
                  <div className="box-header-icon">
                    <div className="bt-icon-list bt-icon-valid" />
                  </div>
                  <div className="text-container label-text text-center text-wrap">
                    {t('Campagnes en ligne')}
                  </div>
                  <div className="box-circle bg-green">
                    {onlineCampaignsCount ? onlineCampaignsCount : '0'}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12" style={{ display: 'flex' }}>
                <div
                  className="card box-wrapper box-pd box-pd-gris"
                  style={{ flex: 1 }}
                  onClick={() => history.push('/SuperAdmin/CampagnesEnBrouillon')}
                >
                  <div className="box-header-icon">
                    <div className="bt-icon-list bt-icon-attr" />
                  </div>
                  <div className="text-container label-text text-center text-wrap">
                    {t('Campagnes en brouillon')}
                  </div>
                  <div className="box-circle bg-gris">
                    {brouillonCampaignsCount ? brouillonCampaignsCount : '0'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
      />

      <ConfirmationModal
        open={confirmation}
        message={confirmationMsg}
        handleClose={() => setConfirmation(false)}
        executeAction={DeleteWebsite}
      />
    </div>
  );
};
